import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  EventEmitter,
  Output
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { ShellRestService } from "./shell.rest";
// import { ShellSideNavService } from './shell-sidenav.service';
import { Subscription } from "rxjs/Subscription";
import { MatSidenav } from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import * as ButtonFocusDropper from "./buttonFocusDropper.js";
import { SettingsService } from "../core/settings/settings.service";
import { UserblockService } from "./sidebar-menu/userblock/userblock.service";
import { Subject } from "rxjs";
const screenfull = require("screenfull");
const browser = require("jquery.browser");
declare var $: any;

@Component({
  selector: "app-shell",
  templateUrl: "./shell.component.html",
  styleUrls: ["./shell.component.scss"],
  providers: [ShellRestService]
})
export class ShellComponent implements OnInit {
  @ViewChild("fsbutton") fsbutton;
  public mobileQuery: MediaQueryList;
  public applicationName: string = "ITS";
  public blockeCustomerText: string;
  private isMobile: boolean;
  private onSideMenuCollapseToggled: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();

  public constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private shellUserService: ShellRestService,
    public settings: SettingsService,
    public userblockService: UserblockService
  ) {
    this.mobileQuery = media.matchMedia("(max-width: 600px)");
    this.mobileQuery.addListener(() => changeDetectorRef.detectChanges());
    // this.shellUserService.GetLoggedUserName().subscribe(u => {
    //   this.loggedUserName = u;
    // });
  }

  
  public ngOnInit() {
    if (browser.msie) {
      // Not supported under IE
      this.fsbutton.nativeElement.style.display = "none";
    }
    ButtonFocusDropper.enableButtonFocusDropper();

    //var item = localStorage.getItem('isBlockedCustomerStr');
    this.shellUserService.IsBlockedCustomer().subscribe((isBlockedCustomer: boolean) => {
      if (isBlockedCustomer)
        this.blockeCustomerText = "Kontrahent jest zablokowany";
    });      
  }

  public ngAfterViewInit() {
    this.isMobile = this.mobileQuery.matches;
    if (this.isMobile) {
      this.settings.setLayoutSetting("asideToggled", true);
    }
  }

  public ngOnDestroy() {
    //this.shellSideNavServiceToggleSubscribtion.unsubscribe();
  }

  toggleCollapsedSideabar() {
    this.settings.toggleLayoutSetting("isCollapsed");
    let isCollapsed = this.settings.getLayoutSetting("isCollapsed");
    this.onSideMenuCollapseToggled.emit(isCollapsed);
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting("isCollapsedText");
  }

  toggleUserBlock(event) {
    event.preventDefault();
    this.userblockService.toggleVisibility();
  }
  toggleFullScreen(event) {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
    // Switch icon indicator
    let el = $(this.fsbutton.nativeElement);
    let isFullscreen = screenfull.isFullscreen;
    if (!isFullscreen) {
      el.children("em")
        .removeClass("icon-size-fullscreen")
        .addClass("icon-size-actual");
    } else {
      el.children("em")
        .removeClass("icon-size-actual")
        .addClass("icon-size-fullscreen");
    }
  }
  toggleOffsidebar() {
    this.settings.toggleLayoutSetting("offsidebarOpen");
  }

  toggleAside() {
    if (this.settings.getLayoutSetting("asideToggled") === true) {
      this.settings.toggleLayoutSetting("asideToggled");
    }
  }
}
